let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("78EgZ")).then(() => parcelRequire('7vTP9'));